<template>
	<v-container grid-list-xs>
		<v-layout row wrap>
			<v-flex xs12 md1>
				<v-btn
					text
					icon
					:loading="loading ? loading : false"
					class="mt-5"
				>
					<v-icon>mdi-reload</v-icon>
				</v-btn>
			</v-flex>
			<v-flex xs12 md12>
				<v-row>
					<v-col cols="12" sm="6" md="6"> </v-col>
					<v-col cols="12" sm="6" md="6">
						<v-flex xs12 md12>
							<filter-chart-order
								v-model="filter"
								:outlets="outlets"
							></filter-chart-order>
						</v-flex>
					</v-col>
				</v-row>
			</v-flex>
			<v-spacer></v-spacer>
			<v-flex xs12 md12 class="py-0 px-0">
				<div class="example">
					<apexchart
						type="line"
						height="350"
						:options="chartOptions"
						:series="data"
					></apexchart>
				</div>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
import TenantLayout from "../../../layouts/tenant.vue";
import TenantReportLayout from "../../../layouts/partials/tenant/report.vue";
import { Link } from "@inertiajs/inertia-vue";
export default {
	layout: [TenantLayout, TenantReportLayout],
	components: {
		Link,
	},
	props: ["data", "outlets"],
	name: "MixedExample",
	data() {
		return {
			item: this.$inertia.form({
				outlet_id: null,
			}),
			filter: {
				date: new Date().toISOString().substr(0, 7),
			},
			loading: false,

			chartOptions: {
				chart: {
					height: 350,
					type: "line",
				},
				stroke: {
					curve: "smooth",
				},
				fill: {
					type: "solid",
					opacity: [0.35, 1],
				},
				labels: [],
				markers: {
					size: 0,
				},
				yaxis: [
					{
						title: {
							text: "Orders",
						},
					},
				],
			},
			tooltip: {
				shared: true,
				intersect: false,
				y: {
					formatter: function (y) {
						if (typeof y !== "undefined") {
							return y.toFixed(0) + " points";
						}
						return y;
					},
				},
			},
		};
	},
};
</script>